{
  "info": "Informacije",
  "negative": "Greška",
  "positive": "Uspešno"
}
